import LottoNav from "../LottoNav";
import {lottoMenus} from "../../constants/nav";
import React from "react";


const Lotto12Nav = () => <LottoNav menus={lottoMenus('lottery12')}/>

export default Lotto12Nav;